
import {Component, Vue} from "vue-property-decorator";
import Vues from 'vue'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vues.use(Viewer)
@Component
export default class HomeClass extends Vue {


    public tabActive:number = 1;

    public active:number=1;
    public options: any = {
        url: 'data-src'
    }

    public more() {
        this.$emit('more')
    }

    public tabClcik(index:any){
        this.active = index;
    }


}
